<template>
  <!-- 議案總表 -->
  <div id="TopicOverView_main">
    <div class="right">
      <el-button
        icon="icon-plus"
        round
        @click="$refs.topicEditDialog.openDialog()"
      >
        臨時動議
      </el-button>
      <el-button
        icon="icon-print"
        round
        @click="$refs.ChooseTopicToPrintDialog.openDialog(topicList, assemblyData.title, $route.params.id)"
      >
        列印投票單
      </el-button>
      <el-button
        icon="icon-output"
        round
        @click="getExcel"
      >
        匯出
      </el-button>
    </div>
    <el-table
      :data="topicList"
      label-position="left"
      label-width="80px"
    >
      <el-table-column
        type="index"
        align="left"
        min-width="10"
      />
      <el-table-column
        label="議案標題"
        prop="title"
        min-width="200"
      >
        <template slot-scope="scope">
          <span
            class="title"
            @click="$refs.topicDetailDialog.openDialog(scope.row.id)"
          >{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="議案狀態"
        min-width="50"
      >
        <template slot-scope="scope">
          {{ progressStatus(scope.row.progressStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        label="出席標準"
        min-width="50"
      >
        <template slot-scope="scope">
          <span class="num">{{ threshold(scope.row.attendanceThreshold) }}％</span>
        </template>
      </el-table-column>
      <el-table-column
        label="投票標準"
        min-width="50"
      >
        <template slot-scope="scope">
          <span class="num">{{ threshold(scope.row.consentThreshold) }}％</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        min-width="100"
      >
        <template slot-scope="scope">
          <!-- 會議未達門檻不顯示表決button，無視議案狀態 -->
          <el-button
            v-if="assemblyData.status != 'Published' && ( scope.row.progressStatus == 'met' || scope.row.progressStatus == 'voting' )"
            size="mini"
            type="primary"
            plain
            @click="checkAssemblyStatus(scope.row)"
          >
            表決
          </el-button>
          <el-button
            v-if="scope.row.progressStatus == 'met' || scope.row.progressStatus == 'notmet'"
            size="mini"
            type="danger"
            plain
            @click="$refs.topicDetailDialog.deleteTopic(scope.row.id)"
          >
            刪除
          </el-button>
          <el-button
            v-if="scope.row.progressStatus == 'decided'"
            size="mini"
            type="primary"
            plain
            @click="goVotePage(scope.row.isAnonymous, scope.row.id)"
          >
            決議結果
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <TopicDetailDialog
      ref="topicDetailDialog"
      :main-threshold="mainThreshold*100"
      @refresh="refresh"
    />
    <TopicEditDialog
      ref="topicEditDialog"
      :main-threshold="mainThreshold*100"
      @refresh="refresh"
    />
    <ChooseTopicToPrintDialog ref="ChooseTopicToPrintDialog" />
  </div>
</template>
<script>
import TopicDetailDialog from './TopicDetailDialog.vue'
import TopicEditDialog from './TopicEditDialog.vue'
import ChooseTopicToPrintDialog from '../print/ChooseTopicToPrintDialog.vue'

export default {
  components: {
    TopicDetailDialog,
    TopicEditDialog,
    ChooseTopicToPrintDialog
  },
  props: {
    assemblyData: Object,
    topicList: Array,
    mainThreshold: Number

  },
  data () {
    return {

    }
  },
  methods: {
    // 取得匯Excel檔案
    getExcel () {
      let file
      apiUnitOwnerAssembly.Vote.GetAssemblyVotingResultExport(
        {
          AssemblyId: this.$route.params.id
        },
        {
          responseType: 'blob'
        }
      ).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          file = res.data
          const url = window.URL.createObjectURL(new Blob([file]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${decodeURIComponent(res.headers['content-disposition'].split(';')[2].replace(/"/g, '').replace("filename*=UTF-8''", '')).trim()}`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    checkAssemblyStatus (row) {
      // eslint-disable-next-line eqeqeq
      if (this.assemblyData.status == 'ThresholdMet') { // 會議已達門檻
        this.$confirm('表決開始後就無法編輯會議資訊及出席名單，確認是否會議開始', '警告', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiUnitOwnerAssembly.Assembly.StartAssembly(
            {
              assemblyId: this.$route.params.id
            }
          ).then(res => {
            // eslint-disable-next-line eqeqeq
            if (res.status == 200) {
              this.$message.success('會議已開始')
              // eslint-disable-next-line eqeqeq
              if (this.assemblyData.useTablet == false && this.assemblyData.useArea == true) { // 當會議僅勾區權比，走特殊流程
                this.startVote(row.id)
              } else { // 其餘議案進入表決選擇頁
                this.$router.push({ name: 'TopicVoteWay', params: { id: this.$route.params.id, topicId: row.id } })
              }
            }
          }).catch((err) => {
            console.log('錯誤訊息：', err.response)
            // eslint-disable-next-line eqeqeq
            if (err.response.status == 500) { this.$message.error(err.response.data.title) }
          })
        }).catch(() => {})
      } else { // 會議已發佈、已開始、已結束
        // eslint-disable-next-line eqeqeq
        if (row.progressStatus == 'voting') {
          this.goVotePage(row.isAnonymous, row.id)
        } else {
          // eslint-disable-next-line eqeqeq
          if (this.assemblyData.useTablet == false && this.assemblyData.useArea == true) { // 當會議僅勾區權比，走特殊流程
            this.startVote(row.id)
          } else { // 其餘議案進入表決選擇頁
            this.$router.push({ name: 'TopicVoteWay', params: { id: this.$route.params.id, topicId: row.id } })
          }
        }
      }
    },
    goVotePage (isAnonymous, topicId) {
      if (isAnonymous) { this.$router.push({ name: 'NotRecordNameVoting', params: { id: this.$route.params.id, topicId } }) } else { this.$router.push({ name: 'RecordNameVoting', params: { id: this.$route.params.id, topicId } }) }
    },
    startVote (topicId) {
      apiUnitOwnerAssembly.Topic.StartVoting(
        {
          assemblyId: this.$route.params.id,
          topicId,
          isAnonymous: false
        }
      ).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.$router.push({ name: 'RecordNameVoting', params: { id: this.$route.params.id, topicId } })
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        // eslint-disable-next-line eqeqeq
        if (err.response && err.response.status == 400) {
          if (err.response.data.description.indexOf('voting') !== -1) { this.$message.warning('此議案已開始投票') } else if (err.response.data.description.indexOf('decided') !== -1) { this.$message.warning('此議案已結束投票') }
        }
      })
    },
    // 刷新議案總表
    refresh () {
      this.$emit('refresh')
    },
    threshold (attendanceThreshold) {
      return parseFloat((attendanceThreshold * 100).toPrecision(12))
    },
    progressStatus (string) {
      return ['未達門檻', '已達門檻', '表決中', '已表決'][['notmet', 'met', 'voting', 'decided'].indexOf(string)]
    }
  }
}
</script>
<style lang="sass" scoped>
#TopicOverView_main
  .right
    float: right
    margin-bottom: 15px
  ::v-deep .el-table
    +basicTable
    .title
      cursor: pointer
      color: $mainColor
      border-bottom: $mainColor 1px solid
      margin-bottom: 1px
    .num
      font-weight: bold
      font-size: 18px
      letter-spacing: 2px
      color: $subFontColor
</style>
